(() => {
    const configNode = document.getElementById('FultonsFinishSamplesConfig');
    if (!configNode) return;
    const config = JSON.parse(configNode.textContent);
    let loading, natuzziLoading, oleandroLoading;
    const natuzziIds = new Set(["15880676376959", "15883544559999", "15883544592767", "15883544658303", "15883544691071", "15883544723839", "15883544756607", "15883544822143", "15883545018751", "15883545379199", "15883546952063", "15883639783807", "15883640177023", "15883640701311", "15883640865151", "15883641094527", "15883641717119", "15883641815423", "15883641880959", "15883641946495", "15883642175871", "15883642274175", "15883642405247", "15883642536319", "15883642667391", "15883642798463", "15883643027839", "15883643093375", "15883643191679", "15883643355519", "15883643453823", "15887216050559", "15887224209791", "15887227781503", "15887242559871", "15887255208319", "15887259042175", "15888710336895", "proposal-natuzzi-editions-forza-x790", "proposal-natuzzi-editions-brama-c070"]);
    const element = (tag, text, className) => {
      const node = document.createElement(tag);
      if (text) node.textContent = text;
      if (className) node.className = className;
      return node;
    };
 const correctNatuzziImage=(sample,key,id,config)=>{const policy=config.natuzziImageCorrections,rule=policy?.productIds?.includes(String(id))?policy.samples?.[key]:null;const shared=(window.FultonsQuieteCoveringImages||{})[key]||(window.FultonsNatuzziThreeCoveringImages||{})[key];if(sample&&rule&&sample.thumbnail===rule.previousThumbnail&&(!rule.previousRegion||JSON.stringify(sample.thumbnailRegion)===JSON.stringify(rule.previousRegion)))return {...sample,thumbnail:rule.thumbnail,thumbnailRegion:null,imageHeld:rule.imageHeld,nativePixelWidth:rule.nativePixelWidth,nativePixelHeight:rule.nativePixelHeight};return sample&&shared?.imageHeld?{...sample,imageHeld:true}:sample;};
    const validImage = value => {
      try { return new URL(value, location.origin).protocol === 'https:'; } catch { return false; }
    };
    const deferredMedia = new WeakMap();
    const deferredMediaObserver = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        const reveal = deferredMedia.get(entry.target); if (reveal) reveal();
        deferredMedia.delete(entry.target); deferredMediaObserver.unobserve(entry.target);
      }
    }, { rootMargin: '160px 0px' }) : null;
    const nearViewport = (node, reveal, immediate = false) => {
      if (immediate || !deferredMediaObserver) { reveal(); return; }
      deferredMedia.set(node, reveal); deferredMediaObserver.observe(node);
    };
    const sizedSource = (source, width) => {
      try {
        const url = new URL(source, location.origin);
        if (url.hostname === 'cdn.shopify.com' || (url.origin === location.origin && url.pathname.startsWith('/cdn/shop/'))) url.searchParams.set('width', width);
        return url.href;
      } catch { return source; }
    };
    const picture = (sample, full = false) => {
      if (!sample.thumbnail) return element('span', sample.imagePlaceholder || config.unavailable, 'fultons-finishes__unavailable');
      if (sample.thumbnailRegion) {
        const r = sample.thumbnailRegion, ns = 'http://www.w3.org/2000/svg';
        const svg = document.createElementNS(ns, 'svg'), image = document.createElementNS(ns, 'image');
        svg.setAttribute('viewBox', `${r.x} ${r.y} ${r.width} ${r.height}`);
        svg.setAttribute('preserveAspectRatio', 'xMidYMid slice');
        svg.setAttribute('role', 'img'); svg.setAttribute('aria-label', sample.label);
        svg.setAttribute('width', '132'); svg.setAttribute('height', '132');
        svg.style.cssText = 'display:block;width:100%;height:auto;aspect-ratio:1;overflow:hidden';
        image.setAttribute('width', r.sourceWidth); image.setAttribute('height', r.sourceHeight);
        nearViewport(svg, () => image.setAttribute('href', sizedSource(sample.thumbnail, 900)), full);
        svg.append(image); return svg;
      }
      const image = element('img');
      // Give ordinary images a source immediately; native lazy loading handles visibility.
      // This also works when custom observers do not reveal images inside reopened panels.
      if (full) image.src = sample.thumbnail;
      else {
        image.sizes = '80px';
        image.srcset = [96,160,240].map(width => sizedSource(sample.thumbnail, width) + ' ' + width + 'w').join(', ');
        image.src = sizedSource(sample.thumbnail, 160);
      }
      image.alt = sample.label;
      image.width = 132;
      image.height = 132;
      image.loading = 'lazy';
      image.decoding = 'async';
      return image;
    };
    const enlarge = (sample, trigger) => {
      const dialog = element('dialog', null, 'fultons-finishes-dialog');
      dialog.setAttribute('aria-labelledby', 'FinishSampleName');
      const close = element('button', config.close, 'fultons-finishes-dialog__close');
      close.type = 'button';
      const image = picture(sample, true);
      image.loading = 'eager';
      if (sample.nativePixelWidth && !sample.thumbnailRegion) image.style.cssText = 'display:block;width:100%;height:auto;object-fit:contain;max-width:' + (sample.nativePixelWidth / Math.max(1, window.devicePixelRatio || 1)) + 'px';
      if (sample.thumbnailRegion) image.style.cssText = 'display:block;width:min(70vw,400px);height:auto;aspect-ratio:1;overflow:hidden';
      const heading = element('h3', sample.label);
      heading.id = 'FinishSampleName';
      const note = element('p', sample.note || config.intro);
      image.addEventListener('error', () => { image.hidden = true; note.textContent = config.unavailable; });
      close.addEventListener('click', () => dialog.close());
      dialog.addEventListener('close', () => { dialog.remove(); trigger.focus(); }, { once: true });
      dialog.addEventListener('click', event => { if (event.target === dialog) { const bounds = dialog.getBoundingClientRect(); if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close(); } });
      dialog.append(close, image, heading, note);
      document.body.append(dialog);
      dialog.showModal();
    };
    const render = async () => {
      const id = String(new URL(location.href).searchParams.get('draft_product') || config.productId || '');
      if (!id) return;
      const root = document.querySelector('#MainContent .catalogue-proof:not([hidden]),#MainContent .pdp-refined:not([hidden])');
      if (!root || root.dataset.finishSamplesLoading === id || root.querySelector('.fultons-finishes')) return;
      root.dataset.finishSamplesLoading = id;
      try {
        loading ||= fetch(config.url).then(response => { if (!response.ok) throw new Error('Finish samples unavailable'); return response.json(); }).catch(error => { loading = null; throw error; });
        let data = await loading;
        if (natuzziIds.has(id)) {
          natuzziLoading ||= fetch(config.natuzzi2026Url).then(response => {
            if (!response.ok) throw new Error('Natuzzi coverings unavailable');
            return response.json();
          }).catch(error => { natuzziLoading = null; throw error; });
          const current = await natuzziLoading;
          if (!current.products[id]) return;
          data = { products: { ...data.products, ...current.products }, swatches: { ...data.swatches, ...current.swatches } };
        }
        if (id === '15887805448575' && config.oleandroUrl) {
          oleandroLoading ||= fetch(config.oleandroUrl).then(response => {
            if (!response.ok) throw new Error('Oleandro finish samples unavailable');
            return response.json();
          }).then(current => {
            for (const sample of Object.values(current.swatches)) {
              if (sample.asset && config.oleandroImages[sample.asset]) sample.thumbnail = config.oleandroImages[sample.asset];
            }
            return current;
          }).catch(error => { oleandroLoading = null; throw error; });
          const current = await oleandroLoading;
          data = { products: { ...data.products, ...current.products }, swatches: { ...data.swatches, ...current.swatches } };
        }
        if (!root.isConnected) return;
        const product = data.products[id];
        if (!product || product.native) return;
        const section = element('section', null, 'fultons-finishes');
        section.classList.toggle('fultons-finishes--range-picker', Boolean(product.rangePicker));
        section.id = 'FultonsAvailableFinishes';
        section.setAttribute('aria-labelledby', 'FultonsAvailableFinishesTitle');
        const heading = element('h2', config.title);
        heading.id = 'FultonsAvailableFinishesTitle';
        section.append(heading, element('p', product.note || config.intro, 'fultons-finishes__intro'));
        let rangeSelect;
        let rangeStatus;
        const rangeGroups = [];
        const groupsContainer = product.rangePicker ? element('div') : section;
        if (product.rangePicker) {
          const label = element('label', config.fabricRange, 'fultons-finishes__range-label');
          rangeSelect = element('select', null, 'fultons-finishes__range-select');
          rangeSelect.id = 'FultonsFabricRange';
          label.htmlFor = rangeSelect.id;
          groupsContainer.id = 'FultonsFabricRanges';
          rangeSelect.setAttribute('aria-controls', groupsContainer.id);
          rangeSelect.add(new Option(config.chooseRange, ''));
          rangeStatus = element('p', config.rangeHelp, 'fultons-finishes__intro');
          rangeStatus.id = 'FultonsFabricRangeStatus';
          rangeStatus.setAttribute('role', 'status');
          rangeSelect.setAttribute('aria-describedby', rangeStatus.id);
          section.append(label, rangeSelect, rangeStatus, groupsContainer);
          const showRange = () => {
            rangeGroups.forEach(({ label, details }) => {
              details.hidden = label !== rangeSelect.value;
              if (!details.hidden) details.open = true;
            });
          };
          rangeSelect.addEventListener('change', () => {
            showRange();
            const group = product.groups.find(item => item.label === rangeSelect.value);
            root.dispatchEvent(new CustomEvent('fultons:fabric-range-changed', {
              detail: { productId: id, selection: group ? {
                range: group.label, category: group.category,
                material: group.material, available: group.modelConfirmed === true
              } : null }
            }));
          });
          root.addEventListener('fultons:upholstery-changed', event => {
            if (event.detail.productId !== id) return;
            rangeSelect.value = event.detail.range || '';
            showRange();
            rangeStatus.textContent = event.detail.range
              ? (event.detail.quote ? config.rangeQuote : event.detail.priceText)
              : config.rangeHelp;
          });
        }
        for (const [index, group] of product.groups.entries()) {
          const samples = group.swatches.map(key => correctNatuzziImage(data.swatches[key], key, id, config)).filter(sample => sample && sample.thumbnail && validImage(sample.thumbnail) && !sample.imageHeld && sample.verified !== false && sample.available !== false && sample.selectable !== false);
          if (!samples.length) continue;
          const details = element('details', null, 'fultons-finishes__group');
          details.dataset.swatchShape = group.swatchShape === 'rectangle' ? 'rectangle' : 'square';
          details.open = product.rangePicker || product.groups.length <= 3 || index === 0;
          const categoryLabel = group.category ? (group.material === 'leather' ? config.leatherCategory : config.fabricCategory) + ' ' + group.category : '';
          const groupLabel = group.label + (categoryLabel ? ' — ' + categoryLabel : '');
          const summary=element('summary', groupLabel + ' · ' + samples.length);details.append(summary);
          if (group.note) details.append(element('p', group.note, 'fultons-finishes__intro'));
          const list = element('ul', null, 'fultons-finishes__grid');
          list.id = 'FinishSampleGroup' + index;
          let more;
          const refreshCount=()=>{
            const rows=Array.from(list.children),expanded=product.rangePicker||more?.getAttribute('aria-expanded')==='true';
            rows.forEach((row,i)=>{row.hidden=!expanded&&i>=12;});summary.textContent=groupLabel+' · '+rows.length;
            if(more){more.hidden=rows.length<=12;more.textContent=expanded?config.less:config.more+' ('+rows.length+')';}
            if(!rows.length){details.remove();if(rangeSelect){const selected=rangeSelect.value===group.label;Array.from(rangeSelect.options).find(option=>option.value===group.label)?.remove();if(selected){rangeSelect.value='';rangeSelect.dispatchEvent(new Event('change'));}}}
          };
          samples.forEach((sample, sampleIndex) => {
            const item = element('li');
            item.hidden = !product.rangePicker && sampleIndex >= 12;
            const button = element('button', null, 'fultons-finishes__sample');
            button.type = 'button';
            button.setAttribute('aria-label', config.view + ' ' + sample.label);
            const image = picture(sample);
            const media=image.tagName?.toLowerCase()==='svg'?image.querySelector('image'):image;
            media?.addEventListener('error',()=>{item.remove();refreshCount();},{once:true});
            button.append(image, element('span', sample.label));
            button.addEventListener('click', () => enlarge(sample, button));
            item.append(button);
            list.append(item);
          });
          details.append(list);
          if (!product.rangePicker && samples.length > 12) {
            more = element('button', config.more + ' (' + samples.length + ')', 'fultons-finishes__more');
            more.type = 'button';
            more.setAttribute('aria-expanded', 'false');
            more.setAttribute('aria-controls', list.id);
            more.addEventListener('click', () => {
              const expanded = more.getAttribute('aria-expanded') !== 'true';
              more.setAttribute('aria-expanded', String(expanded));
              refreshCount();
            });
            details.append(more);
          }
          groupsContainer.append(details);
          if (rangeSelect) {
            rangeSelect.add(new Option(groupLabel, group.label));
            details.hidden = true;
            rangeGroups.push({ label: group.label, details });
          }
        }
        if (!section.querySelector('details')) return;
        const overview = root.querySelector('.catalogue-proof__grid,.pdp-refined__grid');
        if (overview) overview.after(section); else root.append(section);
        const description = root.querySelector('.catalogue-proof__description,.pdp-refined__intro');
        if (description) { const jump = element('a', config.jump, 'fultons-finishes__jump'); jump.href = '#FultonsAvailableFinishes'; description.after(jump); }
      } catch (error) {
        delete root.dataset.finishSamplesLoading;
      }
    };
    document.addEventListener('fultons:catalogue-updated', render);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', render, { once: true }); else render();
  })();
